import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";

import styles from "../../styles/menu-mobile.module.scss";

import {
  ChangeIcon,
  LogoutIcon,
  OrdersIcon,
  PuzzleIcon,
  SettingsIcon,
  UsersIcon,
} from "../components/Icons";
import { EnvironmentStorage } from "../tools/EnvironmentStorage";
import { UserStorage } from "../tools/UserStorage";
import { WorkingTime } from "../utils/WorkingTime";
import { SelectActiveUnit } from "./SelectActiveUnit";
import { AccessManager } from "../tools/AccessManager";
import { Environment } from "../core/Environment";

const Chip = ({ value }) => {
  if (!value) {
    return null;
  }

  return <div className={styles.notification}>{value}</div>;
};

const MenuMobile = ({ ordersCount, reloadStoreStatus }) => {
  const { pathname } = useLocation();
  const [visible, setVisible] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const navigate = useNavigate();
  const getColor = (path) =>
    pathname.startsWith(path) ? "#6161ff" : "#4C4C4C";
  const environment = EnvironmentStorage.getEnvironment();

  useEffect(() => {
    const intervalId = setInterval(checkIfIsOpen, 10000);
    checkIfIsOpen();

    return () => {
      clearInterval(intervalId);
    };
  }, [isOpen]);

  useEffect(() => {
    checkIfIsOpen();
  }, [reloadStoreStatus]);

  const checkIfIsOpen = () => {
    const environmentConfigurations = EnvironmentStorage.getConfigurations();
    const { working_time, active } = environmentConfigurations;

    if (!active || !working_time) {
      setIsOpen(false);
    } else {
      const workingTimeObj = WorkingTime.fromObject(working_time);
      const open = workingTimeObj.isOpen();
      setIsOpen(open);
    }
  };

  const routes = [
    {
      name: "Pedidos",
      path: "/pedidos",
      icon: <OrdersIcon color={getColor("/pedidos")} />,
      show: true,
      fn: () => {
        return ordersCount == 0 ? "" : ordersCount > 10 ? "10+" : ordersCount;
      },
    },
    // {
    //   name: "Atendimento",
    //   path: "/atendimento",
    //   icon: <OrdersIcon color={getColor("/atendimento")} />,
    //   show: UserStorage.isGodMode,
    // },
    {
      name: "Configurações",
      path: "/configuracoes",
      icon: <SettingsIcon color={getColor("/configuracoes")} />,
      show: AccessManager.hasGroup("CONFIGURATION"),
    },
    {
      name: "Integrações",
      path: "/integracoes",
      icon: <PuzzleIcon color={getColor("/integracoes")} />,
      show: AccessManager.hasGroup("INTEGRATION"),
    },
    {
      name: "Usuários",
      path: "/usuarios",
      icon: <UsersIcon color={getColor("/usuarios")} />,
      show: true,
    },
    {
      name: "Logout",
      action: () => {
        UserStorage.setAccessToken(null);
        EnvironmentStorage.setEnvironment(null);
        EnvironmentStorage.setConfigurations(null);
        Environment.uninstall();
        AccessManager.setPermissions([]);
        navigate("/entrar");
      },
      icon: <LogoutIcon color={getColor("/logout")} />,
      show: true,
    },
  ];

  const enabledRoutes = routes.filter((route) => route.show === true);

  return (
    <>
      <nav className={styles.menuMobileContainer}>
        <ul className={styles[pathname.split("/")[1]]}>
          {enabledRoutes.map((item) => {
            return (
              <li key={item.name}>
                {item.path ? (
                  <Link to={item.path} className={styles.item}>
                    <div className={styles.icon}>{item.icon}</div>
                    {typeof item.fn === "function" && item.fn && (
                      <Chip value={item.fn()} />
                    )}
                  </Link>
                ) : (
                  <div onClick={item.action} className={styles.item}>
                    <div className={styles.icon}>{item.icon}</div>
                    {typeof item.fn === "function" && item.fn && (
                      <Chip value={item.fn()} />
                    )}
                  </div>
                )}
              </li>
            );
          })}
        </ul>

        <div className={styles.menuSideRight}>
          <div className={styles.selectUnit} onClick={() => setVisible(true)}>
            <span className="d-flex align-center">
              <ChangeIcon />
            </span>
          </div>
        </div>
      </nav>

      <SelectActiveUnit visible={visible} onClose={() => setVisible(false)} />
    </>
  );
};

export default MenuMobile;
